// Action Type Constant
export const aiActions = {
  SET_AI_SIDEBAR_MODE: 'SET_AI_SIDEBAR_MODE',
  GET_CHAT_HISTORIES: 'GET_CHAT_HISTORIES',
  GET_CHAT_HISTORIES_SUCCESS: 'GET_CHAT_HISTORIES_SUCCESS',
  GET_CHAT_HISTORIES_FAILURE: 'GET_CHAT_HISTORIES_FAILURE',
  ADD_CHAT: 'ADD_CHAT',
  ADD_CHAT_SUCCESS: 'ADD_CHAT_SUCCESS',
  ADD_CHAT_FAILURE: 'ADD_CHAT_FAILURE',
  DELETE_CHAT: 'DELETE_CHAT',
  DELETE_CHAT_SUCCESS: 'DELETE_CHAT_SUCCESS',
  DELETE_CHAT_FAILURE: 'DELETE_CHAT_FAILURE',
  SET_SELECTED_CHAT_HISTORY: 'SET_SELECTED_CHAT_HISTORY',
};

// Action Creator
// export const toggleAiSidebar = (mode) => ({
export const setAiSidebarMode = mode => ({
  type: aiActions.SET_AI_SIDEBAR_MODE,
  payload: mode,
});
